import { Subhead } from '@xo-union/tk-ui-typography';
import React from 'react';

import Styles from '../styles.scss';

const ContentCard = ({ header, icon: Icon, children }) => (
	<div className={Styles.contentCard}>
		<div className={Styles.icon}>
			<Icon />
		</div>
		<Subhead as="h3" bold className={Styles.subhead}>
			{header}
		</Subhead>
		{children}
	</div>
);

export default ContentCard;
